import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../Image';

import {
  anchorTopLg,
  absolute,
  relative,
  header,
  noPointer,
  linkStyles,
  workTitleWrapper,
  workTitle,
} from './styles';
import {
  wrapper,
  halfWidth,
  fullWidthSm,
  center,
  hideOnSm,
} from '../../styles';

const WorkTile = ({ work }) => (
  <Link to={work.link} {...halfWidth} {...fullWidthSm} {...relative}>
    <Image sources={work.headerImage} />
    <div {...center} {...linkStyles} {...workTitleWrapper}>
      <h4 {...workTitle}>{work.title}</h4>
    </div>
  </Link>
);

const WorkNav = ({ prev, next }) => (
  <div {...relative}>
    <div {...anchorTopLg} {...noPointer}>
      <h3 {...header} {...noPointer}>
        Other projects
      </h3>
      <div {...absolute} {...hideOnSm}>
        <svg
          width="100%"
          height="50%"
          viewBox="0 0 100 50"
          xmlns="http://www.w3.org/2000/svg"
          align="xMaxYMax"
        >
          <polygon points="0,0 100,0 50,50, 0,0" fill="#fff" />
        </svg>
      </div>
    </div>
    <div {...wrapper}>
      <WorkTile work={prev} />
      <WorkTile work={next} />
    </div>
  </div>
);

export default WorkNav;



// WEBPACK FOOTER //
// ./src/components/WorkNav/WorkNav.js